import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Top",
    component: () => import(/* webpackChunkName: "top" */ "../views/Top.vue")
  },
  {
    path: "/membership/provisional/mail",
    name: "MailAddress",
    component: () =>
      import(
        /* webpackChunkName: "mailAddressInput" */ "../views/member/MailAddress.vue"
      )
  },
  {
    path: "/membership/password/edit",
    name: "PasswordEdit",
    component: () =>
      import(
        /* webpackChunkName: "passwordEdit" */ "../views/authentication/PasswordEdit.vue"
      )
  },
  {
    path: "/membership/regist",
    name: "MemberInfoRegist",
    component: () =>
      import(
        /* webpackChunkName: "memberInfoRegist" */ "../views/member/MemberInfoRegist.vue"
      )
  },
  {
    path: "/membership/password/reissue",
    name: "PasswordReissue",
    component: () =>
      import(
        /* webpackChunkName: "PasswordReissue" */ "../views/authentication/PasswordReissue.vue"
      )
  },
  {
    path: "/notice",
    name: "Notice",
    component: () =>
      import(/* webpackChunkName: "notice" */ "../views/notice/Notice.vue")
  },
  {
    path: "/notice/detail",
    name: "NoticeDetail",
    component: () =>
      import(
        /* webpackChunkName: "noticeDetail" */ "../views/notice/NoticeDetail.vue"
      )
  },
  {
    path: "/contact",
    name: "Contact",
    component: () =>
      import(/* webpackChunkName: "contact" */ "../views/contact/Contact.vue")
  },
  {
    path: "/plan-select/search",
    name: "SearchPlan",
    component: () =>
      import(
        /* webpackChunkName: "searchPlan" */ "../views/plan/SearchPlan.vue"
      )
  },
  {
    path: "/plan/constr/input",
    name: "ConstructInput",
    component: () =>
      import(
        /* webpackChunkName: "constructInput" */ "../views/construct/Construct.vue"
      )
  },
  {
    path: "/plan/detail",
    name: "PlanDetail",
    component: () =>
      import(
        /* webpackChunkName: "planDetail" */ "../views/plan/PlanDetail.vue"
      )
  },
  {
    path: "/plan/complete",
    name: "PlanComplete",
    component: () =>
      import(
        /* webpackChunkName: "planComplete" */ "../views/plan/PlanComplete.vue"
      )
  },
  {
    path: "/mypage",
    name: "SavedPlanList",
    component: () =>
      import(
        /* webpackChunkName: "savedPlanList" */ "../views/savedplan/SavedPlanList.vue"
      )
  },
  {
    path: "/mypage/saved-plan/detail",
    name: "SavedPlanDetail",
    component: () =>
      import(
        /* webpackChunkName: "savedPlanDetail" */ "../views/savedplan/SavedPlanDetail.vue"
      )
  },
  {
    path: "/mypage/saved-plan/deleteComplete",
    name: "SavedPlanDeleteComplete",
    component: () =>
      import(
        /* webpackChunkName: "savedPlanDeleteComplete" */ "../views/savedplan/SavedPlanDeleteComplete.vue"
      )
  },
  {
    path: "/mypage/saved-plan/updateComplete",
    name: "SavedPlanUpdateComplete",
    component: () =>
      import(
        /* webpackChunkName: "savedPlanUpdateComplete" */ "../views/savedplan/SavedPlanUpdateComplete.vue"
      )
  },
  {
    path: "/mypage/financing-plan",
    name: "FinancingPlan",
    component: () =>
      import(
        /* webpackChunkName: "financingPlan" */ "../views/financingplan/FinancingPlan.vue"
      )
  },
  {
    path: "/mypage/document-download",
    name: "DocumentDownload",
    component: () =>
      import(
        /* webpackChunkName: "documentDownload" */ "../views/documentDownload/DocumentDownload.vue"
      )
  },
  {
    path: "/mypage/document-upload",
    name: "DocumentUpload",
    component: () =>
      import(
        /* webpackChunkName: "documentUpload" */ "../views/documentUpload/DocumentUpload.vue"
      )
  },
  {
    path: "/mypage/document-offer",
    name: "DocumentOffer",
    component: () =>
      import(
        /* webpackChunkName: "documentOffer" */ "../views/documentoffer/DocumentOffer.vue"
      )
  },
  {
    path: "/mypage/moving-quotation",
    name: "MovingQuotation",
    component: () =>
      import(
        /* webpackChunkName: "documentOffer" */ "../views/movingquotation/MovingQuotation.vue"
      )
  },
  // スケジュール管理
  {
    path: "/mypage/schedule",
    name: "Schedule",
    component: () =>
      import(
        /* webpackChunkName: "schedule" */ "../views/schedule/Schedule.vue"
      )
  },
  // ログイン（経由）
  {
    path: "/via/login",
    name: "ViaLogin",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "viaLogin" */ "../views/authentication/Login.vue"
      )
  },
  {
    path: "/error",
    name: "Error",
    component: () =>
      import(/* webpackChunkName: "error" */ "../views/common/Error.vue")
  },
  //ADD静的コンテンツ
  {
    //サービス概要
    path: "/service",
    name: "Service",
    component: () =>
      import(/* webpackChunkName: "service" */ "../views/static/Service.vue")
  },
  {
    //基本構造・性能
    path: "/basicstructure",
    name: "Basicstructure",
    component: () =>
      import(
        /* webpackChunkName: "basicstructure" */ "../views/static/Basicstructure.vue"
      )
  },
  {
    //標準仕様・設備
    path: "/standardspecifications",
    name: "Standardspecifications",
    component: () =>
      import(
        /* webpackChunkName: "standardspecifications" */ "../views/static/Standardspecifications.vue"
      )
  },
  {
    //標準仕様・設備
    path: "/standardSpecificationsVarys",
    name: "StandardSpecificationsVarys",
    component: () =>
      import(
        /* webpackChunkName: "standardspecificationsVarys" */ "../views/static/StandardSpecificationsVarys.vue"
      )
  },
  {
    //会社概要
    path: "/company",
    name: "Company",
    component: () =>
      import(/* webpackChunkName: "company" */ "../views/static/Company.vue")
  },
  {
    //利用規約
    path: "/terms",
    name: "Terms",
    component: () =>
      import(/* webpackChunkName: "terms" */ "../views/static/Terms.vue")
  },
  {
    //地盤改良の重要性
    path: "/improveGround",
    name: "ImproveGround",
    component: () =>
      import(
        /* webpackChunkName: "improveGround" */ "../views/static/ImproveGround.vue"
      )
  },
  {
    //プライバシーポリシー
    path: "/privacypolicy",
    name: "PrivacyPolicy",
    component: () =>
      import(
        /* webpackChunkName: "privacypolicy" */ "../views/static/Privacypolicy.vue"
      )
  },
  {
    //サイトポリシー
    path: "/sitepolicy",
    name: "SitePolicy",
    component: () =>
      import(
        /* webpackChunkName: "Sitepolicy" */ "../views/static/Sitepolicy.vue"
      )
  },
  {
    //モデルハウス予約
    path: "/reservation",
    name: "Reservation",
    component: () =>
      import(
        /* webpackChunkName: "reservation" */ "../views/static/Reservation.vue"
      )
  },
  {
    // 契約申込
    path: "/mypage/contract",
    name: "Contract",
    component: () =>
      import(
        /* webpackChunkName: "Contract" */ "../views/contract/Contract.vue"
      )
  },
  {
    // 火災保険正式見積依頼
    path: "/mypage/fire-insurance-quotation",
    name: "FireInsuranceQuotation",
    component: () =>
      import(
        /* webpackChunkName: "fireInsuranceQuotation" */ "../views/fireinsurancequotation/FireInsuranceQuotation.vue"
      )
  },
  {
    //資金計画画像表示画面
    path: "/FinancingPlanImageDisp/:imgSrc",
    name: "FinancingPlanImageDisp",
    component: () =>
      import(
        /* webpackChunkName: "financingPlanImageDisp" */ "../components/financingplan/FinancingPlanImageDisp.vue"
      ),
    props: route => ({ imgSrc: route.params.imgSrc })
  },
  {
    //SNSポリシー
    path: "/snspolicy",
    name: "SnsPolicy",
    component: () =>
      import(
        /* webpackChunkName: "snspolicy" */ "../views/static/Snspolicy.vue"
      )
  },
  //ADD静的コンテンツ
  {
    path: "*",
    component: () =>
      import(/* webpackChunkName: "error" */ "../views/common/Error.vue")
  },
  //完成立合確認書
  {
    path: "/mypage/completeWitness",
    name: "CompleteWitness",
    component: () =>
      import(
        /* webpackChunkName: "completeWitness" */ "../views/approval/CompleteWitness.vue"
      )
  },
  //建築建物引渡書
  {
    path: "/mypage/transfer",
    name: "Transfer",
    component: () =>
      import(
        /* webpackChunkName: "transfer" */ "../views/approval/Transfer.vue"
      )
  },
  //its house-planlist
  {
    path: "/top/livPlanList",
    name: "LivPlanList",
    component: () =>
      import(
        /* webpackChunkName: "livPlanList" */ "../components/top/LivPlanList.vue"
      )
  },
  //varys-lineUp
  {
    path: "/top/lineUp",
    name: "LineUp",
    component: () =>
      import(
        /* webpackChunkName: "lineUp" */ "../components/top/LineUp.vue"
      )
  },
  //varys-floor
  {
    path: "/top/varysLineUp/varysFloor",
    name: "VarysFloor",
    component: () =>
      import(
        /* webpackChunkName: "varysFloor" */ "../components/top/VarysFloor.vue"
      )
  },
  //URL期限切れ
  {
    path: "/mailAuthKeyExpired",
    name: "MailAuthKeyExpired",
    component: () =>
      import(
        /* webpackChunkName: "MailAuthKeyExpired" */ "../views/member/MailAuthKeyExpired.vue"
      )
  },
  {
    path: "/storeList",
    name: "StoreList",
    component: () =>
      import(
        /* webpackChunkName: "StoreList" */ "../components/storelist/StoreList.vue"
      )
  }
];

const router = new VueRouter({
  mode: "history",
  routes,
  data() {
    return {};
  },
  // スクロール位置調整
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      const position = {};
      if (to.name == "Top") {
        if (to.hash) {
          position.selector = to.hash;
          position.y = 100;
          return position;
        }
      }
      return new Promise(resolve => {
        setTimeout(() => {
          resolve({ x: 0, y: 0 });
        }, 500);
      });
    }
  }
});

// ブラウザボタン
window.popStateDetected = false;
window.addEventListener("popstate", () => {
  window.popStateDetected = true;
});
var isForward = false;
var tempStateKey = 0;
window.onpopstate = function(event) {
  // ブラウザの「戻る」か「進む」かを判定
  var stateKey = event.state.key;
  // console.log(tempStateKey + " : " + stateKey);
  isForward = tempStateKey != 0 && parseInt(tempStateKey) < parseInt(stateKey);
  tempStateKey = parseInt(stateKey);
};
// パラメータ（params）バックアップ
var bkParams = undefined;
/**
 * 画面遷移処理
 * @param to : 遷移先情報
 * @param from : 遷移元情報
 * @param next : 画面遷移処理（メソッド）
 */
router.beforeEach((to, from, next) => {
  const UNNECESSARY_LOADING_LIST = [
    "Error",
    "Service",
    "Basicstructure",
    "Standardspecifications",
    "Company",
    "Terms",
    "PrivacyPolicy",
    "SitePolicy",
    "Reservation",
    "SnsPolicy",
    "ImproveGround",
    "LivPlanList",
    "LineUp",
    "VarysFloor",
    "MailAuthKeyExpired"
  ];
  // ローディング表示
  if (to.name && !UNNECESSARY_LOADING_LIST.includes(to.name)) {
    store.commit("setScreenLoading", true);
  } else {
    store.commit("setScreenLoading", false);
  }
  // ブラウザ戻るボタンによる遷移
  const BrowserCtrl = window.popStateDetected;
  window.popStateDetected = false;
  if (BrowserCtrl) {
    if (!isForward) {
      /** 戻る */
      // console.log(from.name + " : " + to.name);
      // パラメータ（params）を一時的に保持
      if (from.name == "ConstructInput") bkParams = from.params;
      let mypagePath = "/mypage";
      if (
        to.path &&
        !to.path.indexOf(mypagePath) &&
        !from.path.indexOf(mypagePath)
      ) {
        // マイページ以内のブラウザ移動
        if (from.query && from.query.simulationNo) {
          router.replace({
            name: to.name,
            query: { simulationNo: from.query.simulationNo }
          });
        } else {
          router.replace({ name: "SavedPlanList" });
        }
      } else if (
        to.path &&
        !to.path.indexOf(mypagePath) &&
        from.path.indexOf(mypagePath)
      ) {
        router.replace({
          name: to.name,
          query: { simulationNo: to.query.simulationNo }
        });
      } else if (from.name == "PlanDetail" && to.name == "ConstructInput") {
        // 基本プラン詳細 ⇒ 建築地入力
        if (!to.params.planId) {
          // バックスペースで遷移:引数（基本プランID）を設定する。
          router.replace({
            name: to.name,
            params: {
              planId: from.query.planId,
              specDiv: from.query.specDiv,
              entranceDirectionCd: from.query.entranceDirectionCd
            }
          });
        }
      } else if (from.name == "PlanDetail" && to.name == "PlanDetail") {
        // プラン詳細、仕様変更
        router.replace({
          name: to.name,
          query: {
            planId: to.query.planId,
            specDiv: to.query.specDiv,
            entranceDirectionCd: to.query.entranceDirectionCd
          }
        });
      } else {
        router.replace({ name: to.name });
      }
    } else {
      /** 進む */
      tempStateKey = 0;
      if (bkParams) {
        // console.log(bkParams);
        next({ name: to.name, params: bkParams });
        bkParams = undefined;
      } else {
        // console.log("noneParam");
        next();
      }
    }
  } else {
    // RouterLinkによる遷移
    // 建築地入力:URL直打ちの場合はTop画面に遷移
    if (to.name == "ConstructInput") {
      if (!to.params || !to.params.planId) {
        next({ name: "Top" });
      } else {
        next();
      }
      // } else if (to.name == "SearchPlan") {
      //   // プラン検索はSTEP1で表示しない…
      //   next({ name: "Top" });
    } else {
      next();
    }
  }
});

export default router;
